import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowUpRight, ArrowRight, Check } from 'lucide-react';
import { ParallaxSection } from '../components/ParallaxSection';
import { DevelopmentAreas } from '../components/DevelopmentAreas';
import { companies } from '../data/companies';
export function ServicesPage() {
  return <div className="bg-white" data-id="element-300" data-mp="276n8du2845ft">
      <ParallaxSection backgroundImage="https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=1920&q=80" height="h-[50vh]" data-id="element-301" data-mp="2c8mcx79p98ec">
        <div className="text-center" data-id="element-302" data-mp="2g7ld6ekhkgzg">
          <p className="text-[#C5A55A] text-xs md:text-sm tracking-[0.35em] uppercase mb-5" data-id="element-303" data-mp="2kzwdhij524sj">
            Services
          </p>
          <h1 className="text-4xl md:text-6xl font-serif font-bold text-white" data-id="element-304" data-mp="2py691u8rz7eo">
            We Develop. We Build. We Craft.
          </h1>
        </div>
      </ParallaxSection>

      {/* Intro */}
      <section className="py-20 px-6 md:px-10" data-id="element-305" data-mp="2zyqe77zf0w26">
        <div className="max-w-4xl mx-auto" data-id="element-306" data-mp="2zvavzwag36wj">
          <p className="text-xl md:text-2xl text-gray-700 font-light leading-relaxed" data-id="element-307" data-mp="2xl2i5xmyt7rg">
            Three Sinclair companies cover a property from the first look at the
            land through the last cabinet door. Work with one of them, or let us
            carry the whole project.
          </p>
        </div>
      </section>

      {/* The companies */}
      <section className="pb-8 px-6 md:px-10" data-id="element-308" data-mp="3gaix3pzed2re">
        <div className="max-w-7xl mx-auto space-y-20 md:space-y-28" data-id="element-309" data-mp="3g97hmswla6kg">
          {companies.map((company, index) => {
          const isExternal = Boolean(company.url);
          return <motion.article key={company.name} initial={{
            opacity: 0,
            y: 24
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-80px'
          }} transition={{
            duration: 0.3,
            ease: [0.23, 1, 0.32, 1]
          }} className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center" data-id="element-310" data-mp="36jnz5ocsgeq4" data-mpi={index}>
                <div className={`lg:col-span-7 ${index % 2 === 1 ? 'lg:order-2' : ''}`} data-id="element-311" data-mp="1se2op64bp9pb">
                  <img src={company.image} alt={company.name} className="w-full h-64 md:h-[420px] object-cover" data-id="element-312" data-mp="1xb2stbhm42ds" />
                </div>

                <div className="lg:col-span-5" data-id="element-313" data-mp="1njopesmjiifd">
                  <p className="text-xs tracking-[0.25em] uppercase text-gray-500 mb-4" data-id="element-314" data-mp="19l8jv50eyxyt">
                    {company.name}
                  </p>
                  <h2 className="text-3xl md:text-5xl font-serif font-bold text-black mb-5" data-id="element-315" data-mp="1eja4vvheh7cx">
                    {company.tagline}
                  </h2>
                  <div className="w-14 h-[2px] bg-[#C5A55A] mb-6" data-id="element-316" data-mp="14o8desznjt76" />
                  <p className="text-gray-600 leading-relaxed mb-8" data-id="element-317" data-mp="2u2d6pa6uwgpl">
                    {company.description}
                  </p>

                  <ul className="space-y-3 mb-9" data-id="element-318" data-mp="2z059iz91hn8k">
                    {company.offerings.map(offering => <li key={offering} className="flex items-start gap-3 text-black" data-id="element-319" data-mp="nee7riyy322d">
                        <Check className="w-4 h-4 text-[#C5A55A] mt-1 shrink-0" aria-hidden="true" data-id="element-320" data-mp="x464ojuio7a0" />
                        <span data-id="element-321" data-mp="sb4peaqee5pw">{offering}</span>
                      </li>)}
                  </ul>

                  {isExternal ? <a href={company.url as string} target="_blank" rel="noopener noreferrer" className="group inline-flex items-center gap-2 bg-black hover:bg-[#C5A55A] text-white hover:text-black px-8 py-4 font-medium rounded-sm transition-colors duration-200" data-id="element-322" data-mp="121zb9dzqf3at">
                      Visit {(company.url as string).replace('https://', '')}
                      <ArrowUpRight className="w-5 h-5 transition-transform duration-200 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" aria-hidden="true" data-id="element-323" data-mp="3ebzflclw9vk1" />
                    </a> : <Link to="/contact" className="group inline-flex items-center gap-2 bg-[#C5A55A] hover:bg-[#D4AF37] text-black px-8 py-4 font-medium rounded-sm transition-colors duration-200" data-id="element-324" data-mp="3o8aumacvczi6">
                      Bring us an opportunity
                      <ArrowRight className="w-5 h-5 transition-transform duration-200 group-hover:translate-x-0.5" aria-hidden="true" data-id="element-325" data-mp="35jnqbu2ioe5n" />
                    </Link>}
                </div>
              </motion.article>;
        })}
        </div>
      </section>

      <DevelopmentAreas data-id="element-326" data-mp="2hsibni8bbrwx" />

      <ParallaxSection backgroundImage="https://images.unsplash.com/photo-1590274853856-f22d5ee3d228?w=1920&q=80" height="h-[50vh]" data-id="element-327" data-mp="2hryvo7283dlj">
        <div className="text-center" data-id="element-328" data-mp="uyesidr14fic">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-6" data-id="element-329" data-mp="uv8zinfa4thc">
            One team, start to finish.
          </h2>
          <Link to="/contact" className="inline-block bg-[#C5A55A] hover:bg-[#D4AF37] text-black px-10 py-4 text-lg font-bold rounded-sm transition-colors duration-200" data-id="element-330" data-mp="kzp8offkokzg">
            Start the conversation
          </Link>
        </div>
      </ParallaxSection>
    </div>;
}